var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-wrap"},[_c('webview',{attrs:{"src":"https://m.kuaidi100.com/help/contraband.html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }